



























import {
  defineComponent,
  ref,
  watch,
  useContext,
  computed
} from '@nuxtjs/composition-api';
import { useVSFContext } from '@vue-storefront/core';
import { priceFormat } from '~/helpers/utils';
import { useTranslations } from '@vue-storefront/novulo';

export default defineComponent({
  props: {
    errorMessage: { type: String, default: '' },
    isInvalid: { type: Boolean, default: false },
    minimum: { type: Number, default: 0 },
    maximum: { type: Number, default: 9999 },
    isActive: {
      type: Boolean,
      default: true
    }
  },
  setup(props, { emit }) {
    const { translate } = useTranslations();
    const { i18n } = useContext();
    const minValue = ref('');
    const maxValue = ref('');
    const appliedErrorMessage = ref(props.errorMessage);
    const hasError = ref(props.isInvalid);
    const vsfContext = useVSFContext();
    const wt = vsfContext.$vsf.$novulo.config.state.getWt();

    const handleNotify = () => {
      const min = minValue.value ? parseInt(minValue.value) : props.minimum;
      const max = maxValue.value ? parseInt(maxValue.value) : props.maximum;
      if (min > max) return;
      emit('update', {
        min,
        max
      });
    };

    const handleMinValueUpdate = (value: string) => {
      minValue.value = value;
      handleNotify();
    };

    const handleMaxValueUpdate = (value: string) => {
      maxValue.value = value;
      handleNotify();
    };

    const isCurrencyAfter = computed(() => i18n.localeProperties.code === 'fr');
    const currency = wt === 37 ? '£' : '€';

    watch(
      () => props.isActive,
      (newValue) => {
        if (newValue) return;
        minValue.value = '';
        maxValue.value = '';
      }
    );

    return {
      translate,
      minValue,
      maxValue,
      handleMinValueUpdate,
      handleMaxValueUpdate,
      appliedErrorMessage,
      hasError,
      isCurrencyAfter,
      currency,
      priceFormat
    };
  }
});
